/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Roles_OverlineInputs */

const en_mk_sec_pg_roles_overline = /** @type {(inputs: Mk_Sec_Pg_Roles_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

const id_mk_sec_pg_roles_overline = /** @type {(inputs: Mk_Sec_Pg_Roles_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peran`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Mk_Sec_Pg_Roles_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_roles_overline = /** @type {((inputs?: Mk_Sec_Pg_Roles_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Roles_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_roles_overline(inputs)
	return en_mk_sec_pg_roles_overline(inputs)
});